export default __webpack_public_path__ + "static/media/icomoon.a1f54f05.ttf";